import dayjs from "dayjs";
import React, { useState } from "react";
import { FullPageLayout } from "../../../components/FullPageLayout"
import { Container } from "../../common/modules.styles";
import { axiosInstance } from "../../../utils/axios";
import { Typeahead } from "react-bootstrap-typeahead";
import styled from "styled-components";

function useData() {
    const [recipes, setRecipes] = useState<{ id: number, name: string }[]>([]);
    
    const fetchRecipes = async () => {
        try {
            const response = await axiosInstance('/recipes/get-recipes');
            setRecipes(response.data);
        } catch (error) {
            console.error("Error fetching recipes", error);
        }
    }

    React.useEffect(() => {
        fetchRecipes();
    }, []);

    return { recipes };
}

type Fill = {
    amount: number;
    date: string;
    product: {
        name: string;
    }
    filledBy: { username: string } | null;
}

type Production = {
    id: number;
    date: string;
    state: string;
    recipe: {
        name: string;
    }
    fills: Fill[];
}

export default function ProductionsHistoryPage() {
    const {recipes} = useData();
    const [recipe, setRecipe] = useState<{ id: number, name: string }[]>([]);
    const [desde, setDesde] = useState('');
    const [hasta, setHasta] = useState(dayjs().format('YYYY-MM-DD'));
    const [results, setResults] = useState<Production[] | null>(null);

    const handleFilter = async (e: React.FormEvent) => {
        e.preventDefault();
        // fetch filtered data
        try {
            const response = await axiosInstance.get('/productions/productions-history', {
                params: {
                    recipeId: recipe.length > 0 ? recipe[0].id : 'all',
                    desde,
                    hasta   
                }
            });
            setResults(response.data);
        } catch (error) {
            console.error("Error fetching filtered productions history", error);
        }
    }

    return (
        <FullPageLayout>
            <Container>
                <h2>Historial de Producciones</h2>
                <div id="filters-form">
                    <form onSubmit={handleFilter} style={{ display: "flex", gap: "1rem", flex: 1 }}>
                        <div className="mb-3" style={{ flex: 1 }}>
                            <label htmlFor="recipe" className="form-label">Receta</label>
                            <Typeahead
                                id="recipe"
                                labelKey="name"
                                onChange={setRecipe}
                                options={recipes}
                                placeholder="Seleccione una receta..."
                                selected={recipe}
                            />
                        </div>
                        <div className="mb-3" style={{ flex: 1 }}>
                            <label htmlFor="startDate" className="form-label">Fecha de inicio</label>
                            <input type="date" className="form-control" id="startDate" value={desde} onChange={(e) => setDesde(e.target.value)} />
                        </div>
                        <div className="mb-3" style={{ flex: 1 }}>
                            <label htmlFor="endDate" className="form-label">Fecha de fin</label>
                            <input type="date" className="form-control" id="endDate" value={hasta} onChange={(e) => setHasta(e.target.value)} required />
                        </div>
                        <button  type="submit" className="mb-3 btn btn-primary">Filtrar</button>
                    </form>
                </div>
                <div id="history-table" style={{overflowY: "scroll"}}>
                    {results ? (
                        results.length > 0 ? (
                            results.map((production : Production) => (
                                <ProductionsHistoryItem key={production.id} production={production} />
                            ))
                        ) : (
                            <p>No se encontraron producciones con los filtros aplicados.</p>
                        )
                    ) : null}
                </div>
            </Container>
        </FullPageLayout>
    );
}

const ProductionHistoryItem = styled.div`
    display: flex;
    flex-direction: column;
    border: 1px solid #ccc;
    border-radius: 5px;
    margin-bottom: 1rem;
`;

const ProductionInfo = styled.div`
    display: flex;
    justify-content: space-between;
    font-weight: bold;
    align-items: center;
    padding: 0.5rem;
    border-bottom: 1px solid #ccc;
    background-color: #f9f9f9;
    &:hover { background-color: #e0e0e0; cursor: pointer; }
`;

const FillingHistory = styled.div`
    padding: 0 0.5rem;
`;

const FillItem = styled.div`
        display: flex;
        justify-content: space-between;
        padding: 0.5rem 0;
        &:not(:first-child) {
            border-top: 1px solid #eee;
        }
`;

function ProductionsHistoryItem({ production }: { production: Production }) {
    const [showed, setShowed] = useState(false);

    const toggleShowed = () => setShowed(!showed);

    return (
        <ProductionHistoryItem id="production-history-item">
            <ProductionInfo onClick={toggleShowed}>
                <div>{dayjs(production.date).format('DD-MM-YYYY')}</div>
                <div>{production.recipe.name}</div>
                <div>{production.state}</div>
            </ProductionInfo>
            <FillingHistory id="filling-history" style={{ display: showed ? 'block' : 'none' }}>
                {production.fills?.map((fill: any) => (
                    <FillItem key={fill.id}>
                        <div>{dayjs(fill.date).format('DD-MM-YYYY')}</div>
                        <div><strong>{fill.amount}</strong> {fill.product.name || "N/A"}</div>
                        <div>{fill.filledBy?.username || "N/A"}</div>
                    </FillItem>
                ))}
            </FillingHistory>
        </ProductionHistoryItem>
    );
}